import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import NotificationPopup from "./NotificationPopup";
import useApp from "../../store/contexts/AppContext";
import { loadPopupNotifPref } from "./NotificationSettings";

export default function GlobalNotifications() {
  const {
    appState: { chats, userData },
    popupNotifications,
    dismissPopupNotification,
    switchActiveChat,
  } = useApp();

  const history = useHistory();
  const location = useLocation();
  const pref = loadPopupNotifPref();

  if (!userData?.id || pref === 'off') return null;

  const onMessagesPage = location.pathname.startsWith('/messages');
  if (pref === 'messages' && !onMessagesPage) return null;

  const handleNotificationClick = (notification) => {
    const chatToOpen = chats.find(
      (chat) => chat.id?.toString() === notification.roomId?.toString()
    );
    if (chatToOpen) switchActiveChat(chatToOpen);
    history.push("/messages");
  };

  return (
    <NotificationPopup
      notifications={popupNotifications}
      onDismiss={dismissPopupNotification}
      onNotificationClick={handleNotificationClick}
      bottomOffset={20}
    />
  );
}
